import { defineNuxtRouteMiddleware, navigateTo } from '#imports'

export default defineNuxtRouteMiddleware((to, from) => {
	const nuxtApp = useNuxtApp()

	if (to.path.includes('/forgot/reset') && from.path === nuxtApp.$localePath('/login/')) {
		return navigateTo({ path: nuxtApp.$localePath('/') })
	}
})
